import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';

import { SpoLockingPluginService } from './spo-locking-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';

import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

@Component({
    selector: 'spo-locking-edit',
    templateUrl: './spo-locking-edit.component.html',
    standalone: false
})
export class SpoLockingPluginPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  public spoLockings: any[];
  public initialSpoLockings: any;
  public processing = false;

  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private service: SpoLockingPluginService,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.goToBack();

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save() {
    this.processing = true;
    this.service.updateSpoLocking(this.inspectionId, this.pointId, this.pluginId, this.spoLockings).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.spoLockings = this.plugin.config.SpoLockings.map((x: any) => Object.assign({}, x));
      if (!this.spoLockings || this.spoLockings.length === 0) {
        this.spoLockings = [];
        let initialLenght = 1;
        while (initialLenght < 7) {
          this.spoLockings.push({ Id: initialLenght });
          initialLenght++;
        }
      }
      this.cdRef.detectChanges();
    });
  }

  add() {
    const id = Math.max(...this.spoLockings.map((l) => l.Id)) + 1;
    this.spoLockings.push({ Id: id });
  }

  remove(id: number) {
    this.spoLockings = this.spoLockings.filter((l) => l.Id !== id);
    this.spoLockings.forEach((value, i) => {
      value.Id = i + 1;
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin() {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
